import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["stepper", "step", "previous", "next", "progress"];
  static values = { index: Number, max: Number };

  connect() {
    this.showStepper();
    this.showCurrentStep();
    this.disableOrEnablePreviousButton();
    this.disableOrEnableNextButton();
    this.updateProgress();
  }

  next() {
    this.indexValue++;
  }

  previous() {
    this.indexValue--;
  }

  indexValueChanged() {
    this.showCurrentStep();
    this.disableOrEnablePreviousButton();
    this.disableOrEnableNextButton();
    this.updateProgress();
  }

  showStepper() {
    this.stepperTarget.hidden = false;
  }

  showCurrentStep() {
    this.stepTargets.forEach((element, index) => {
      element.hidden = index !== this.indexValue;
    });
  }

  disableOrEnablePreviousButton() {
    if (this.indexValue === 0) {
      this.previousTarget.disabled = true;
    } else {
      this.previousTarget.disabled = false;
    }
  }

  disableOrEnableNextButton() {
    if (this.indexValue === this.maxValue) {
      this.nextTarget.disabled = true;
    } else {
      this.nextTarget.disabled = false;
    }
  }

  updateProgress() {
    this.progressTargets.forEach((element) => {
      element.textContent = this.indexValue + 1;
    });
  }
}
